import img1 from '../Images/projects_images/1.jpg'
import img2 from '../Images/projects_images/2.jpg'
import img3 from '../Images/projects_images/3.jpg'
import img4 from '../Images/projects_images/4.jpg'
import img5 from '../Images/projects_images/5.jpg'
import img6 from '../Images/projects_images/6.jpg'
import img7 from '../Images/projects_images/7.jpg'
import img8 from '../Images/projects_images/8.jpg'
import img9 from '../Images/projects_images/9.jpg'
import img10 from '../Images/projects_images/10.jpg'
import img11 from '../Images/projects_images/11.jpg'
import img12 from '../Images/projects_images/12.jpg'

export default [

    {
      name: 'Perfect White',
      description: '#fdfbfb → #ebedee',
      css: img5,
      height: 400,
    },
    {
      name: 'Near Moon',
      description: '#5ee7df → #b490ca',
      css: img6,
      height: 400,
    },
    {
      name: 'Wild Apple',
      description: '#d299c2 → #fef9d7',
      css: img7,
      height: 200,
    },
    {
      name: 'Ladoga Bottom',
      description: '#ebc0fd → #d9ded8',
      css: img8,
      height: 400,
    },
    {
      name: 'Sunny Morning',
      description: '#f6d365 → #fda085',
      css: img9,
      height: 200,
    },
    {
      name: 'Lemon Gate',
      description: '#96fbc4 → #f9f586',
      css: img10,
      height: 400,
    },
    {
      name: 'Salt Mountain',
      description: ' #FFFEFF → #D7FFFE',
      css: img11,
      height: 200,
    },
    {
      name: 'New York',
      description: ' #fff1eb → #ace0f9',
      css: img12,
      height: 400,
    },


  ]
  